import { render } from "./NotificationBox.vue?vue&type=template&id=ab3bfa94&scoped=true"
import script from "./NotificationBox.vue?vue&type=script&lang=js"
export * from "./NotificationBox.vue?vue&type=script&lang=js"

import "./NotificationBox.vue?vue&type=style&index=0&id=ab3bfa94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3bfa94"]])

export default __exports__